import React, { useEffect, useState} from "react";
import {PropertyContainerComponent} from "../../widgets/toolbox/PropertyContainerComponent";
import {BehaviorModal} from "./BehaviorModal";


interface BehaviorPanelProps {
    notifyParent?: (expJson: any, state: string) => void;
    getExperience?: () => any;
    getBaseUrl: () => string;
}

const styleClasses = {
    behaviorCtrlBtn: "behavior-control-btn",
    behaviorCtrlContainer: "behavior-control-container",
};

const LoggedInUserState = require("shared/ui/user/LoggedInUserState"),
      Configuration = require("shared/services/Configuration"),
      Storage       = require("shared/services/Storage");

export default function BehaviorSettings(props: BehaviorPanelProps) {
    const [modalOpen, setModalOpen] = useState(false);

    const [permissionFlag, setPermissionFlag] = useState(false);
    const getConnectSettings = () => {
        const companyId = LoggedInUserState.attributes.company.id,
            settingName = "connect",
            endpointUrl = `${Configuration.creatorSettingApiBaseUrl}/v1/settings/${companyId}?name=${settingName}`,
            token = Storage.Local.get(Storage.Keys.LOGIN, "token") || Storage.Session.get(Storage.Keys.LOGIN, "token"),
            bearerToken = `Bearer ${token}`;

        const options = {
            method: "GET",
            headers: {
                Authorization: bearerToken,
            },
        };

        fetch(endpointUrl, options)
            .then((res) => res.json())
            .then((data) => {
                Storage.Local.update(Storage.Keys.CREATOR_CONNECT, data.connect);
                if (data.connect) setPermissionFlag(data.connect.enabled && data.connect.ipd.enabled);
            })
            .catch((err) => console.log(err));
    };

    const isActionEnabled = () => {
        let initialLoadCount = Storage.Local.get(Storage.Keys.CREATOR_CONNECT, Storage.Keys.BEHAVIOR_COMPONENT_INIT_COUNT) || 0;
        Storage.Local.update(Storage.Keys.CREATOR_CONNECT, Storage.Keys.BEHAVIOR_COMPONENT_INIT_COUNT, ++initialLoadCount);
        if(initialLoadCount <= 1) {
            getConnectSettings();
        }
        else {
            const connectSetting = Storage.Local.get(Storage.Keys.CREATOR_CONNECT);
            setPermissionFlag(connectSetting.enabled && connectSetting.ipd.enabled);
        }
    }

    useEffect(isActionEnabled, [permissionFlag]);

    const handleOpen = () => {
        setModalOpen(true);
    };

    const handleClose = () => {
        setModalOpen(false)
    }

    const workFlowModal = (): JSX.Element => {
        return (
            <BehaviorModal open={modalOpen} expJson = {props.getExperience()} fonts={""} handleClose={handleClose} baseUrl = {props.getBaseUrl()} notifyExpJson={props.notifyParent}></BehaviorModal>
        );
    };

    return (
        permissionFlag ? (
        <PropertyContainerComponent
            widgetSelected={false}
            label={"Behaviors"}
            name={"behaviors"}
            animateExpandOnMount={false}
        >
            <div className={styleClasses.behaviorCtrlContainer}>
                <button className={styleClasses.behaviorCtrlBtn} onClick={handleOpen}>Manage Behaviors</button>
            </div>
            {modalOpen && workFlowModal()}
        </PropertyContainerComponent>
        )  : <></>
    );
}



// WEBPACK FOOTER //
// ./src/editor/ui/experience/action/behavior/BehaviorSettings.tsx